import buildUrl from 'modules/core/lib/buildUrl'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

export type UserForAvatar = {
  access: {
    id: string
  }
  avatar: {
    url: string
  } | null
  firstName: string | null
  lastName: string | null
}

export const getMemberAvatars = (ownerAccessIds: string[], users: UserForAvatar[]) => {
  const members = users.filter((user) => ownerAccessIds.includes(user.access.id))

  const avatarStack = members.map((member) => {
    return {
      label: getFullDisplayName({
        firstName: member.firstName,
        lastName: member.lastName,
      }),
      url: buildUrl(member.avatar?.url),
    }
  })

  return avatarStack
}
